import { render, staticRenderFns } from "./TQAnalysisPage.vue?vue&type=template&id=037f9fcc&"
import script from "./TQAnalysisPage.vue?vue&type=script&lang=js&"
export * from "./TQAnalysisPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports